'use client'
import ReactDOM from 'react-dom'
import React, { useEffect, useState, useRef } from 'react'

import Icon from '@/components/Icon/Icon'

import styles from './Modal.module.scss'
import classNames from 'classnames/bind'
const classes = classNames.bind(styles)

/**
 * Creates a modal on the page at the body tag.
 *
 * @param {Boolean} open A boolean determining whether the modal should be showing or not.
 * @param {Function} setOpen A function to allow the modification of the open property.
 * @param {Element} children Any child elements.
 *
 */
export default function Modal({ open, setOpen, children, extraClass = null, notBody = false, allowClose = true }) {
    // Set state to determine if the browser is loaded, default to false.
    const [browserLoaded, setBrowserLoaded] = useState(false)
    const nodeRef = useRef(null)

    // Use useEffect to set browser loaded to true.
    useEffect(() => {
        setBrowserLoaded(true)
    })

    // Prevent the rendering of anything if the browser isn't loaded or if open is false.
    if (!browserLoaded || !open) return null

    const modal = (
        <div
            className={classes('overlay', { closed: !open })}
            onMouseDown={(e) => {
                if (e.target !== e.currentTarget || !allowClose) return null
                setOpen(false)
            }}
            ref={nodeRef}
        >
            <div className={classes('popup-wrapper')}>
                <div className={classes(`popup`, extraClass)}>
                    {/* Add a close button function to close the popup. */}
                    <div
                        className={classes('close-button', { hidden: !allowClose })}
                        onClick={() => {
                            if (!allowClose) return
                            setOpen(false)
                        }}
                    >
                        <Icon name="close" />
                    </div>
                    {/* Add the children to the content part of the popup. */}
                    {children}
                </div>
            </div>
        </div>
    )

    if (notBody) {
        return modal
    } else {
        // Create a portal to add the overlay to the body of the document to avoid overflow issues.
        return ReactDOM.createPortal(
            modal,
            // Add to the document body.
            document.body
        )
    }
}
